import { Route } from '@/core/router.types'
import type Administration from './Administration'
import type SyncHistoryRoute from './Details/features/Integrations/components/SyncHistory/SyncHistory'
import EntraIntegration from './Details/features/Integrations/routes/EntraIntegration'
import OktaIntegration from './Details/features/Integrations/routes/OktaIntegration'
import PersonioIntegration from './Details/features/Integrations/routes/PersonioIntegration'

/*****
 *
 * Administration page routes..
 */

export default [
  {
    menu: { label: 'administration_admin', icon: 'Administration' },
    path: '/administration',
    query: '',
    authorize: ['customer_success', 'customer_manager', 'global_customer_manager'],
    flushTop: true,
    component: () => import(/* webpackChunkName: "Administration" */ './Administration'),
    response: (data: unknown) => ({
      title: 'Administration',
      description: 'Use the search to start support tasks for Administration.',
      props: data,
    }),
  } as unknown as Route<typeof Administration>,
  {
    path: '/administration/integrations/sync-history/:provider/:tenant',
    query: '',
    authorize: ['customer_success', 'customer_manager', 'global_customer_manager'],
    component: () =>
      import(
        /* webpackChunkName: "SyncHistory" */ './Details/features/Integrations/components/SyncHistory/SyncHistory'
      ),
    response: (data: unknown) => ({
      title: 'Integration Sync History',
      description: 'View integration synchronization history and issues',
      props: data,
    }),
  } as unknown as Route<typeof SyncHistoryRoute>,
  {
    path: '/administration/integrations/okta/:step/:subStep?',
    query: '',
    authorize: ['customer_success', 'customer_manager', 'global_customer_manager'],
    component: () =>
      import(/* webpackChunkName: "OktaIntegration" */ './Details/features/Integrations/routes/OktaIntegration'),
    response: (data: unknown) => ({
      title: 'Okta Integration',
      description: '',
      props: data,
    }),
  } as unknown as Route<typeof OktaIntegration>,
  {
    path: '/administration/integrations/entra/:step/:subStep?',
    query: '',
    authorize: ['customer_success', 'customer_manager', 'global_customer_manager'],
    component: () =>
      import(/* webpackChunkName: "EntraIntegration" */ './Details/features/Integrations/routes/EntraIntegration'),
    response: (data: unknown) => ({
      title: 'Entra Integration',
      description: '',
      props: data,
    }),
  } as unknown as Route<typeof EntraIntegration>,
  {
    path: '/administration/integrations/personio/:step?/:subStep?',
    query: '',
    authorize: ['customer_success', 'customer_manager', 'global_customer_manager'],
    component: () =>
      import(
        /* webpackChunkName: "PersonioIntegration" */ './Details/features/Integrations/routes/PersonioIntegration'
      ),
    response: (data: unknown) => ({
      title: 'Personio Integration',
      description: '',
      props: data,
    }),
  } as unknown as Route<typeof PersonioIntegration>,
] as const
